<template>
    <div>
        <v-card>
            <v-toolbar dark color="secomdary">
                <v-spacer></v-spacer>
                <v-toolbar-title>Product Doc. List</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn @click="onCreateNewDoc" small color="primary">Add Doc.</v-btn>
            </v-toolbar>
            <v-card-text>
                <v-layout row>
                    <v-flex xs12 body-2 pt-1>
                        <v-select
                        v-model="docCategoryIdSelected"
                        :items="docCategories"
                        item-text="name"
                        item-value="id"
                        box
                        label="Class To Search"
                        ></v-select>
 
                    </v-flex>
                    <v-flex xs12 text-xs-center pt-1>
                        <v-btn @click="getDocs" large color="primary">Search</v-btn>
                    </v-flex>
                </v-layout>
                <v-layout>
                    <v-flex xs12 body-2 pt-1>Result:</v-flex>

                </v-layout>
                <v-data-table
                    :headers="headers"
                    :items="itmDocs"
                    hide-actions
                    >
                    <template slot="items" slot-scope="props">
                      <td class="px-1 text-no-wrap">{{ props.item.docName }}</td>
                      <td class="px-1">{{ props.item.docCategoryId }}</td>
                      <td class="px-1 text-xs-center text-no-wrap">{{ props.item.status }}</td>
                      <td class="px-1 text-xs-center"><a :href="props.item.docUrl" target="_blank">{{ props.item.docUrl }}</a></td>

                        <td>{{props.item.notes}}</td>
                        <td>
                            <v-btn small color="primary" @click="onEditItem(props.item)" >Edit</v-btn>
                            <!-- <v-btn small color="primary" @click.prevent="$emit('onDeleteItem', props.item)" >Delete</v-btn> -->
                        </td>
                    </template>
                </v-data-table>

            </v-card-text>
        </v-card>
        <v-dialog v-model="showItmDocEditPopup" width="600" height="500">
            <ctlItmDocEdit 
                :itemDoc="itmDocToEdit"
                @onCloseItmDocEdit="onCloseItmDocEdit"
                ></ctlItmDocEdit>
        </v-dialog>

    </div>
</template>
<script>
import ctlItmDocEdit from '@/components/productDb/ctlItmDocEdit.vue'
import { mapActions } from 'vuex'
export default {
    // props: ['itemDocs'],
    components: {
        ctlItmDocEdit,
    },
    data() {
        return {
            docCategories: [
                // {id: 'brochure', name: 'Brochure'},
                // {id: 'priceList', name: 'Price List'},
                // {id: 'ifu', name: 'IFU'},
                // {id: 'memo', name: 'Memo'},
                // {id: 'sds', name: 'SDS'},
                {id: 'productUrl', name: 'ProductUrl'},
            ],
            docCategoryIdSelected: 'productUrl',
            itmDocs: [],
            headers: [
                { text: 'Name', sortable: false},
                { text: 'Category' , sortable: false},
                { text: 'Status' , sortable: false},
                { text: 'URL', sortable: false, class: ['px-1']},
                { text: '', sortable: false}
            ],
            itmDocToEdit: null,
            showItmDocEditPopup: false,
        }
    },
    methods: {
        ...mapActions('adminItemProdDb', [
            'getItmDocs'
        ]),
        async getDocs() {
            this.itmDocs = await this.getItmDocs(this.docCategoryIdSelected)
        },
        onCreateNewDoc() {
            this.itmDocToEdit = {
                // id = doc.Id,
                // docCategoryId = doc.ItmDocCategory.Id,
                // docName = doc.DocName,
                // docUrl = doc.DocUrl,
                status: 'active',
                // notes = doc.Notes,

            }
            this.showItmDocEditPopup = true
        },
        onEditItem(itmDoc) {
            this.itmDocToEdit = itmDoc
            this.showItmDocEditPopup = true
        },
        onCloseItmDocEdit() {
            this.itmDocToEdit = null
            this.showItmDocEditPopup = false
            this.getDocs()
        }
    },
    created() {
        this.getDocs()
    }
}
</script>